/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CndnRequest } from '../../models/cndn-request';

export interface ApiRequestCndnInitialGet$Params {
}

export function apiRequestCndnInitialGet(http: HttpClient, rootUrl: string, params?: ApiRequestCndnInitialGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CndnRequest>> {
  const rb = new RequestBuilder(rootUrl, apiRequestCndnInitialGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CndnRequest>;
    })
  );
}

apiRequestCndnInitialGet.PATH = '/api/Request/Cndn/Initial';
